function parseQueryString(queryString: string) {
    let result = {};

    if (!queryString) {
        return result;
    }

    let vars = queryString.split('&');
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    return result;
}

/**
 * Helper function to parse URL query params in path.
 *
 *  @param path; for example "/manageApplications?page=1&size=4"
 * @return hash object with query params, for example {page: "1", size="4"}
 */
export function parse(path: string): any {
    if (!path  ||  path.indexOf('?') <= -1) {
        return {};
    }

    let end = path.length;
    if (path.indexOf('#') > -1) {
        end = path.indexOf('#');
    }

    let query = path.substring(path.indexOf('?') + 1, end);
    return parseQueryString(query);

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/helpers/query-parser.ts